import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import moment from 'moment'
import {getMediaWallProgram} from '@apis'

const NodeOnlineRate = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo
    const [todayPlayProgram, setTodayPlayProgram] = useState([])
    const [nextPlayProgram, setNextPlayProgram] = useState([])

    // 获取节点信息
    async function querytNodeList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMediaWallProgram(params)
      if (res && res.data) {
        let today = []
        let nextDay = []
        res.data.map(item => {
          if(item.taskSwitch == 1) {
            if(item.playFrequency == 1) {
              item.weekList.map(e => {
                if(e == new Date().getDay()) {
                  today.push(item.name)
                }
                if(e == new Date().getDay()+1) {
                  nextDay.push(item.name)
                }
                if(new Date().getDay() == 7 && e == 1) {
                  nextDay.push(item.name)
                }
              })
            } else {
              if(moment(new Date().valueOf()).format('YYYY:MM:DD') >= moment(Number(item.playDayStart)).format('YYYY:MM:DD') 
              && moment(new Date().valueOf()).format('YYYY:MM:DD') <= moment(Number(item.playDayEnd)).format('YYYY:MM:DD')) {
                today.push(item.name)
              }
              if(moment(new Date().valueOf()+24*60*60*1000).format('YYYY:MM:DD') >= moment(Number(item.playDayStart)).format('YYYY:MM:DD') 
              && moment(new Date().valueOf()+24*60*60*1000).format('YYYY:MM:DD') <= moment(Number(item.playDayEnd)).format('YYYY:MM:DD')) {
                nextDay.push(item.name)
              }
            }
          }
        })
        setTodayPlayProgram(today)
        setNextPlayProgram(nextDay)
      }
    }

    useEffect(() => {
      querytNodeList()
    }, [])

    return (
      <div className='ck-index-node'>
        <div className='node-title'>节目播放单</div>
        <div className='node-item'>
          <div className='node-left'>
            <div className='node-left-title'>今日播放节目单</div>
            <div className='node-left-list'>
              {
                todayPlayProgram.length ? todayPlayProgram.map(item => (
                  <div>{item}</div>
                )) : (<div>暂无</div>)
              }
            </div>
          </div>
          <div className='node-right'>
            <div className='node-right-title'>明日播放节目单</div>
            <div className='node-right-list'>
              {
                nextPlayProgram.length ? nextPlayProgram.map(item => (
                  <div>{item}</div>
                )) : (<div>暂无</div>)
              }
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default NodeOnlineRate